// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for event coverage check job.

Daily check to ensure event kinds have sufficient slot coverage based on
EventKindCoverage configuration. No parameters needed as it evaluates all
event kinds for the tenant.
 */
export interface EventCoverageCheckParams {
  [key: string]: unknown;
}
